if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButtons = this.querySelectorAll('[type="submit"]');
        this.submitButtons.forEach((button) => {
          if (document.querySelector("cart-drawer")) {
            button.setAttribute("aria-haspopup", "dialog");
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        let activeSubmitButton = evt.submitter || this.querySelector('[type="submit"]');
        
        if (document.querySelector(".upsell-is-active")) {
          activeSubmitButton = document.querySelector(".upsell-is-active");
        }

        if (activeSubmitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        activeSubmitButton.setAttribute("aria-disabled", true);
        activeSubmitButton.classList.add("loading");
        activeSubmitButton
          .querySelector(".loading-overlay__spinner")
          .classList.remove("hidden");

        const config = fetchConfig("javascript");
        delete config.headers["Accept"];

        const formData = new FormData(this.form);

        const object = {};
        formData.forEach(function (value, key) {
          if (key === "quantity" || key === "id") {
            object[key] = parseInt(value);
          } else {
            object[key] = value;
          }
        });
        const formDataUpdate = {
          items: [object],
        };

        // Add product rebuy upsells to cart
        if (document.querySelectorAll(".product-rebuy").length > 0) {
          document.querySelectorAll(".product-rebuy").forEach((input) => {
            if (input.checked) {
              const itemObject = {
                quantity: 1,
                id: input.id,
              };
              formDataUpdate.items.push(itemObject);
            }
          });
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);

          formDataUpdate["sections"] = this.cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(",");
          formDataUpdate["sections_url"] = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(formDataUpdate);

        fetch(`${routes.cart_add_url}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                activeSubmitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              activeSubmitButton.setAttribute("aria-disabled", true);
              activeSubmitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            activeSubmitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) activeSubmitButton.removeAttribute("aria-disabled");
            if (document.querySelector(".product-rebuy-submit"))
              document
                .querySelector(".product-rebuy-submit")
                .classList.remove("upsell-is-active");
            activeSubmitButton
              .querySelector(".loading-overlay__spinner")
              .classList.add("hidden");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            // Refresh Rebuy product list
            rebuy_recommended();
            // Affirm cart drawer messaging
            affirm.ui.refresh();
            _mktz.push(['_Goal', 'add-to-cart', 1]);
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
// UUID is needed for the recently viewed endpoind
function getRebuyUuid() {
  return new Promise((resolve, reject) => {
    const checkRebuyStatus = setInterval(() => {
      if (
        typeof Rebuy !== "undefined" &&
        Rebuy._status === "initialized" &&
        typeof Rebuy.identity === "function"
      ) {
        clearInterval(checkRebuyStatus);
        resolve(Rebuy.identity().uuid);
      }
    }, 100);
  });
}

class rebuyWidget extends HTMLElement {
  constructor() {
    super();
    this.targetElement = this.querySelector(".product-rebuy-content");
    this.template = this.querySelector("template");
    this.submitButton = this.querySelector(".product-rebuy-submit");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.renderProducts();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
  renderProducts() {
    getRebuyUuid().then((uuid) => {
      const requestParameters = new URLSearchParams({
        shopify_product_ids: this.dataset.ids,
        limit: this.dataset.limit,
        key: "5b81a3fb05d63ee9ceb7fa196b14fc2c6f45ce90",
        uuid: uuid,
      });

      fetch(this.dataset.url + requestParameters)
        .then((response) => response.json())
        .then((data) => {
          const templateHtml = this.template.innerHTML;
          const result = Mustache.render(templateHtml, data.data);
          this.targetElement.innerHTML += result;
          if (data.data.length === 0) {
            this.style.display = "none";
          } else {
            this.style.visibility = "visible";
            this.closest(".rebuy-container").style.visibility = "visible";
          }
          this.eventHandlers();
        })
        .catch((e) => {
          console.log("The error:");
        });
    });
  }
  eventHandlers() {
    this.inputs = this.querySelectorAll(".product-rebuy");
    this.inputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        this.priceAndItemsSubmitUpdate(this.inputs);
      });
    });

    this.submitButton.addEventListener("click", (event) => {
      this.submitButton.classList.add("upsell-is-active");
      document.querySelector(".product-form__submit").click();
    });
  }
  priceAndItemsSubmitUpdate(inputs) {
    let items = [
      {
        id: this.dataset.product,
        quantity: 1,
      },
    ];
    let totalPrice = parseInt(
      this.querySelector("#product-rebuy-total").dataset.price
    );
    inputs.forEach((input) => {
      input.checked == true &&
        (totalPrice += parseFloat(input.dataset.price) * 100);
      if (input.checked) {
        let item = {
          id: input.id,
          quantity: 1,
        };
        items.push(item);
      }
    });

    // Update the total price in the widget footer
    this.querySelector("#product-rebuy-total").textContent =
      Shopify.formatMoney(totalPrice);
  }
}

customElements.define("rebuy-widget", rebuyWidget);

// Convermax
class convermaxWidget extends HTMLElement {
  constructor() {
    super();
    this.targetElement = this.querySelector(".product-convermax-content");
    this.template = this.querySelector("template");
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.renderProducts();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
  renderProducts(show_only_model = false, count = 0) {
    const query = this.buildQuery(show_only_model);
    fetch(`https://pertronix.myconvermax.com/search.json?${query}`)
      .then((response) => response.json())
      .then((data) => {
        const products = data.Items;
        if (data.Messages.length == 0 || count > 1) {
          const products_to_render = [];
          products.forEach((product) => {
            if (
              product.id !== this.dataset.id &&
              products_to_render.length < 4
            ) {
              products_to_render.push(product);
            }
          });
          if (products_to_render.length > 0) {
            const templateHtml = this.template.innerHTML;
            const result = Mustache.render(templateHtml, products_to_render);
            this.targetElement.innerHTML += result;
            this.closest(".rebuy-container").style.visibility = "visible";
          } else {
            this.renderProducts(true, count + 1);
          }
        } else {
          this.renderProducts(true, count + 1);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
  buildQuery(show_only_model = false) {
    let query = "";
    if (!show_only_model) {
      query = new URLSearchParams({
        query: this.dataset.product.trim(),
        pagesize: this.dataset.limit + 1,
      }).toString();
    } else {
      query = new URLSearchParams({
        pagesize: this.dataset.limit + 1,
      }).toString();
    }
    if (
      localStorage.getItem("cm_variant-model") != null &&
      this.dataset.product.trim().toLowerCase() != "apparel"
    ) {
      let str = "";
      const arr = JSON.parse(localStorage.getItem("cm_variant-model"));
      for (let i = 0; i < arr.length; i++) {
        str += `facet.${i}.field=${arr[i].field}&facet.${i}.selection=${arr[i].term}`;
        if (i < arr.length - 1) {
          str += "&";
        }
      }
      query += "&" + str;
    }
    return query;
  }
}

customElements.define("convermax-widget", convermaxWidget);

(function () {
  function waitForElm(selector) {
    return new Promise((resolve) => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver((mutations) => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }

  waitForElm("#cm-verify-fitment").then((elm) => {
    const observer = new MutationObserver((mutations) => {
      // Use a class or attribute as a marker to check if the changes have already been applied
      if (document.querySelector(".cm_verify-fitment__modified")) return;

      const no_fitment = elm.querySelector(".cm_verify-fitment__no");
      if (no_fitment) {
        const title = document.querySelector(".cm_verify-fitment_title");
        const container = document.querySelector(
          ".cm_verify-fitment_compatible-parts-container"
        );
        const button = document.querySelector(
          ".cm_verify-fitment_compatible-parts-container a"
        );

        // Apply changes only if they haven't been applied yet
        if (title && container && button) {
          title.innerHTML = no_fitment_title;
          button.innerHTML = no_fitment_button;
          container.innerHTML += no_fitment_text;

          // Add a class or attribute to mark these elements as modified
          title.classList.add("cm_verify-fitment__modified");
          container.classList.add("cm_verify-fitment__modified");
          button.classList.add("cm_verify-fitment__modified");
        }
      }
    });

    observer.observe(document.querySelector("#cm-verify-fitment"), {
      childList: true,
      subtree: true,
    });

    // Immediately apply changes if the element exists before the observer starts
    const no_fitment = elm.querySelector(".cm_verify-fitment__no");
    if (no_fitment && !document.querySelector(".cm_verify-fitment__modified")) {
      const title = document.querySelector(".cm_verify-fitment_title");
      const container = document.querySelector(
        ".cm_verify-fitment_compatible-parts-container"
      );
      const button = document.querySelector(
        ".cm_verify-fitment_compatible-parts-container a"
      );
      if (title && container && button) {
        title.innerHTML = no_fitment_title;
        button.innerHTML = no_fitment_button;
        container.innerHTML += no_fitment_text;

        // Mark these elements as modified
        title.classList.add("cm_verify-fitment__modified");
        container.classList.add("cm_verify-fitment__modified");
        button.classList.add("cm_verify-fitment__modified");
      }
    }
  });
})();

// yotpo reviews
function open_reviews() {
  let reviews_container = "";
  document
    .querySelectorAll(".accordion__title")
    .forEach((accordion_title, index) => {
      if (accordion_title.innerText.toLowerCase().includes("reviews")) {
        const computedStyle = window.getComputedStyle(accordion_title);
        if (computedStyle.display !== "none") {
          reviews_container = accordion_title.closest("details");
          reviews_container.setAttribute("open", true);
          reviews_container.open = true;
          reviews_container.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
}
document.querySelectorAll(".open-reviews").forEach((open_reviews_button) => {
  open_reviews_button.addEventListener("click", (e) => {
    open_reviews();
  });
  open_reviews_button.addEventListener("keyup", (e) => {});
});
